import styles from './CheckInForm.module.scss';
import Button from 'components/Button/Button';
import React, { useState } from 'react';
import SelectComponent from 'components/Input/Select';
import { checkInTypeOptions } from '../../variables';
import DateTimeSelect from 'components/Input/DateTimeSelect';
import { store } from 'stores/Store';
import useExternalApiService from 'helpers/ExternalApiService';

interface ICheckInForm {
  navigateBack: () => void;
}

const CheckInForm = ({ navigateBack }: ICheckInForm) => {
  const [selectedDateTime, setSelectedDateTime] = React.useState<string>(() => {
    const now = new Date();
    // Get the raw time without timezone adjustments
    return new Date(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes()
    ).toISOString();
  });
  const [notes, setNotes] = React.useState('');
  const [practitioners, setPractitioners] = React.useState<any[]>([]);

  // const [selectedPractitioner, setSelectedPractitioner] = React.useState<any>(null);
  const [selectedCheckInType, setSelectedCheckInType] = React.useState<any>(checkInTypeOptions[0]);
  const [selectedFollowUpDate, setSelectedFollowUpDate] = React.useState<string>(new Date().toISOString());
  const apiUrl = process.env.REACT_APP_EAI_URL;
  const [isAddingCheckin, setIsAddingCheckin] = useState(false);
  const { postData } = useExternalApiService(apiUrl);


  const handleSave = async () => {
    let verified = false;
    setIsAddingCheckin(true);
    if ("geolocation" in navigator) {
      try {
        const distance = await new Promise<number>((resolve, reject) => {
          navigator.geolocation.getCurrentPosition((position) => {
            const lat1 = position.coords.latitude;
            const lon1 = position.coords.longitude;
            const lat2 = store.currentPractitioner.latitude;
            const lon2 = store.currentPractitioner.longitude;
    
            // Calculate distance using Haversine formula
            const R = 6371; // Radius of earth in km
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
    
            const a = 
              Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
              Math.sin(dLon/2) * Math.sin(dLon/2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            const distance = R * c;
    
            resolve(Math.round(distance * 0.621371)); // Convert to miles and round
          }, (error) => {
            reject(error);
          });
        });
        
        verified = distance <= 5; // Set verified to true if distance is 5 miles or less
      } catch (error) {
        console.error('Error getting location:', error);
        verified = false;
      }
    }
      
    try {
      await postData('/api/add_checkin', {
        "practitioner_id": store.currentPractitioner.id,
        "checkin_data": {
          "type": selectedCheckInType.value,
          "notes": notes,
          "follow_up_date": selectedFollowUpDate,
          "verified": verified
        }
      });
    } catch (err) {
      console.error(err);
    }
    setIsAddingCheckin(false);
    navigateBack();
  }

  React.useEffect(() => {
    if (store.checkIn) {
      setNotes(store.checkIn.notes ?? '');
    }
    // getPractitioners();
  }, []);

  // const getPractitioners = async () => {
  //   try {
  //     const result = await postData('/api/get_practitioners_for_chat', {"fmc_email": store.impersonatedUser});
  //     const formattedPractitioners = result.practitioners.map((pract: any) => ({
  //       label: pract.primary_name,
  //       value: pract.id,
  //     }));
      
  //     setPractitioners(formattedPractitioners);    
  //     // Only look for the practitioner after we have the data
  //     const practitioner = result.practitioners.find((p: any) => {
  //       return p.id === store.currentPractitioner?.id;
  //     });
  //     if (practitioner) {
  //       setSelectedPractitioner({
  //         label: practitioner.primary_name,
  //         value: practitioner.id,
  //       });
  //     }
  //   } catch (error) {
  //     console.error('Error fetching practitioners:', error);
  //   }
  // };

  return(
    <div className={styles.wrapper}>
      <div className={styles.headerWrapper}>
        <p className={styles.headerText}>Check-In for: </p>
        <div className={styles.btnsWrapper}>          
          <div 
            className={styles["loading-button"]}
            onClick={() => {
              if (!isAddingCheckin) {
                handleSave();
              }
            }}>
            {isAddingCheckin && (
              <>
                <span className={styles["loading-button__loader"]}></span>
                <span className={styles["loading-button__loader-cover"]}></span>
              </>
            )}
            <Button color="#00C542" textColor="white" borderColor="#00C54280" type="outline">
              SAVE
            </Button>
            
            <Button type="outline" onClick={navigateBack}>Cancel</Button>
          </div>
        </div>
      </div>
      <div className={styles["current-pract"]}>{store.currentPractitioner.primary_name}</div>
      {/* <SelectComponent
        value={{label: "Mona Solar", value: "Mona Solar"}}
        onChange={() => {}}
        options={[{label: "Mona Solar", value: "Mona Solar"}]} 
        placeholder="Select a Practitioner" 
      /> */}
      <p className={styles.label}>Time</p>
      <DateTimeSelect 
        value={selectedDateTime} 
        setValue={(e: string) => {
          setSelectedDateTime(e);
          setSelectedFollowUpDate(e);
        }} 
      />
      <p className={styles.label}>Log Type</p>
      <SelectComponent options={checkInTypeOptions} placeholder="Select a Type" value={selectedCheckInType} onChange={(e: any) => setSelectedCheckInType(e)} />
      <p className={styles.label}>Notes</p>
      <textarea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        className={styles.textarea}
        placeholder="Enter your notes here..."
      />
      {/* <p className={styles.label}>Follow-Up Date</p>
      <DateTimeSelect value={selectedFollowUpDate} setValue={setSelectedFollowUpDate}/> */}
    </div>
  )
}

export default CheckInForm;
